import type {WfProcessTypeStepDto} from "./wf-process-type-step.dto";
import {WfProcessTypeStepNextTypeEnum} from "../../../enum/wf-process-type-step-next-type-enum.enum";
import {DtoDetail} from "../../../../../core/shared/dto/dto.detail";

export class WfProcessTypeStepNextDto extends DtoDetail {

    public processTypeStepDto?: WfProcessTypeStepDto;
    public processTypeStepDtoId: number;
    public processTypeStepDtoName: string;

    public name: string;
    public description: string;
    public image: string;
    public rgbaColor: string;
    public position: number;
    public stepNextType: WfProcessTypeStepNextTypeEnum;

    public nextProcessTypeStepDto?: WfProcessTypeStepDto;
    public nextProcessTypeStepDtoId: number;
    public nextProcessTypeStepDtoName: string;

    // BPM layout data
    public bpmDataJson: string;

    // Condition configuration
    public conditionLogicDtoId: number;
    public conditionLogicDtoName: string;
    public conditionDescription: string;
    public conditionPriority: number;
    public isDefaultPath: boolean;

    // Process result (for COMPLETE_PROCESS transitions)
    public processTypeResultDtoId: number;
    public processTypeResultDtoName: string;

}
